import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Company, PurchaseOrderDto } from '@app/models';
import { CompanyService } from '@app/services';
import { Observable } from 'rxjs';
import { LocalStorage } from 'ngx-webstorage';

@Injectable({
  providedIn: 'root',
})
export class SuppliersResolver implements Resolve<Company[]> {
  @LocalStorage() organizationId;

  constructor(private router: Router,
              private companyService: CompanyService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Company[]> {
    return this.companyService.suppliers(this.organizationId);
  }
}
